














































































import {
    PosRealtime, PosRoutes, PosVehiclePosition, PosWaypoint, PosWaypointType,
} from 'gl-ms-positions';
import { flatten } from 'lodash';
import HereMap from '@/components/common/map/map.vue';
import HereGroup from '@/components/common/map/group.vue';
import HereMarker from '@/components/common/map/marker.vue';
import HerePolyline from '@/components/common/map/polyline.vue';
import { COLOR_MAP } from '@/components/fleet/realtime/components/pin.vue';

import { getStaticUrl } from '@/helpers';
import {
    ACTION_EMPTY_VEHICLE,
} from '@/store/modules/realtime';

// eslint-disable-next-line no-multi-str
const baseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="39"> \
    <defs/><g data-name="Group 216"><g><g transform="translate(18 17)" fill="#fff" stroke="COLOR" stroke-width="5">\
    <circle cx="9" cy="9" r="9" stroke="none"/><circle cx="9" cy="9" r="6.5" fill="none"/></g><path d="M27 39l-5-7h10z" fill="COLOR"/></g>\
    <g fill="#fff" stroke="COLOR"><rect width="56" height="15" rx="1" stroke="none"/><rect x=".5" y=".5" width="53" height="14" rx=".5" fill="none"/>\
    </g><text text-align="center" transform="translate(27 11)" fill="#231f20" font-size="12"><tspan x="-23.2" y="0">PLATE</tspan></text></g></svg>';

const TYPES_TO_HIDE: string[] = ['DRAG'];

export default {
    data() {
        return {
            selectedPlate: '',
            top: 0,
            left: 0,
            icon: getStaticUrl('marker_pin.png'),
            currentIcon: '',
        };
    },
    components: {
        HereMap,
        HereGroup,
        HereMarker,
        HerePolyline,
    },
    mounted(this: any) {
        if (this.$route.params.plateId) {
            this.selectedPlate = this.$route.params.plateId;
        }
    },
    computed: {
        waypoints(this: any) {
            const {
                route,
            }: { route: PosRoutes } = this.$store.state.realtime.selectedRoute;
            if (route && Array.isArray(route.waypoints) && route.waypoints.length) {
                return route.waypoints.filter((item: PosWaypoint) => item.config && item.config.includeInRealtimeView).map((item: PosWaypoint) => ({
                    lat: item.geometry.coordinates[1],
                    lng: item.geometry.coordinates[0],
                    icon: baseIcon.replace(/COLOR/g, '#000').replace(/PLATE/g, item.type),
                }));
            }

            return [];
        },
        currentPlate(this: any) {
            return this.$store.state.realtime.currentPlate;
        },
        currentPosition(this: any) {
            const currentRealtime: PosRealtime = this.$store.state.realtime.selectedRoute.realtime;
            let color: string = 'red';
            if (currentRealtime && currentRealtime.position) {
                if (COLOR_MAP[this.$store.state.realtime.selectedRoute.state]) {
                    // @ts-ignore
                    color = COLOR_MAP[this.$store.state.realtime.selectedRoute.state].color;
                }

                return {
                    lat: currentRealtime.position.coordinates[1],
                    lng: currentRealtime.position.coordinates[0],
                    icon: baseIcon.replace(/COLOR/g, color).replace(/PLATE/g, this.currentPlate),
                };
            }

            return undefined;
        },
        expectedTrace(this: any) {
            const { route }: { route: PosRoutes } = this.$store.state.realtime.selectedRoute;
            if (route && (route.expected_route || route.automatic_route)) {
                const currentRoute = route.expected_route || route.automatic_route;
                if (currentRoute) {
                    return flatten(currentRoute.geometry.coordinates);
                }
            }

            return [];
        },
        actualTrace(this: any) {
            const { actualRoute }: { actualRoute: number[] } = this.$store.state.realtime.selectedRoute;
            if (Array.isArray(actualRoute) && actualRoute.length > 0) {
                return actualRoute;
            }

            return [];
        },
        actualEmptyTrace(this: any) {
            const { actualEmptyRoute }: { actualEmptyRoute: number[] } = this.$store.state.realtime.selectedRoute;
            if (Array.isArray(actualEmptyRoute) && actualEmptyRoute.length > 0) {
                return actualEmptyRoute;
            }

            return [];
        },
        isLoadingRoutes(this: any) {
            return this.$store.getters.isLoadingRoutes;
        },
        hasExpected(this: any) {
            return Boolean(this.expectedTrace.length);
        },
        hasActual(this: any) {
            return Boolean(this.actualTrace.length);
        },
        hasActualEmpty(this: any) {
            return Boolean(this.actualEmptyTrace.length);
        },
    },
    methods: {},
};
